/* @flow */
import Image from 'components/Image';
import ImageFilePreviewModal from 'components/ImageFilePreviewModal';
import Link from 'components/Link';
import ModalTrigger from 'components/ModalTrigger';
import * as React from 'react';
import { fileGQLFromV2File } from 'types/typescript/file';

import type { FilePreviewerProps } from 'groups/components/FilePreview';

import './styles/FileImagePreview.scss';

export const FileImagePreview = ({ file }: FilePreviewerProps) => {
  // eslint-disable-line object-curly-spacing
  return (
    <ModalTrigger modal={<ImageFilePreviewModal file={fileGQLFromV2File(file)} />}>
      <Link className="FileImagePreview" eventElementName="FileImagePreview">
        <Image src={file.urls.cdn || ''} alt={file.name} className="FileImagePreview-image" />
      </Link>
    </ModalTrigger>
  );
};

export default FileImagePreview;
